<script>
import Typewriter from '../snippets/Typewriter'

export default {
  name: 'TextFileViewer',

  components: {
    Typewriter
  },

  props: {

    file: {
      type: Object,
      required: true
    },

    data: {
      required: true
    }

  }

}
</script>

<template>
  <typewriter
    :fast="true"
    :message="data"
    class="c-text-file-viewer"
  />
</template>

<style lang="scss">

.c-text-file-viewer-image {
  @include scroll;
  width: 100%;
  height: 100%;
}

</style>
